import repository from '@/services/repository';

const resource = '/Files';

export default {
    lookup(type: string, id: string, folder: string) {
        let qry = `?type=${type}&id=${id}`;
        if (folder) {
            qry += `&folder=${folder}`;
        }
        return repository.get(`${resource}/Lookup` + qry);
    },
    createFolder(type: string, id: string, folder: string) {
        return repository.post(`${resource}/create/folder`, { folder, type, id});
    },
};
